import { React, PT } from '@gasbuddy/react';
import Styles from './styles.css';

export const VerticalCenter = ({ children }) => (
  <div className={Styles.outer}>
    <div className={Styles.middle}>
      <div className={Styles.inner}>
        {children}
      </div>
    </div>
  </div>
);

VerticalCenter.propTypes = {
  children: PT.element,
};

VerticalCenter.defaultProps = {
  children: <div />,
};
